<template>
  <div id="TalkInput" :class="{'active': isActivie}">
    <textarea-autosize
      :placeholder="placeholder"
      ref="TalkInput"
      rows="1"
      v-model="content"
      :class="{'active': isActivie}"
      :min-height="39"
      :max-height="80"/>
    <button :class="{'active': isActivie}" @click="complete">
      <span v-if="isCreateQuestion">
        {{isActivie ? '보내기' : '보내기'}}
      </span>
      <span v-else-if="isCreateAnswer">
        {{isActivie ? '답변달기' : '보내기'}}
      </span>
      <span v-else-if="isUpdateQuestion">
        {{isActivie ? '보내기' : '보내기'}}
      </span>
      <span v-else-if="isUpdateAnswer">
        {{isActivie ? '보내기' : '보내기'}}
      </span>
      <span v-else>
        보내기
      </span>
    </button>
  </div>
</template>

<script>
// Variable Section
let self

export default {
  name: 'TalkInput',
  chimera: {
    createQuestion() { return { url: '/talks/questions/', method: 'post', params: { content: this.content } } },
    createAnswer() { return { url: '/talks/answers/', method: 'post', params: { question: this.$route.params.uuid, content: this.content } } },
    updateQuestion() { return { url: `/talks/questions/${this.questionEdit ? this.questionEdit.uuid : ''}/`, method: 'patch', params: { content: this.content } } },
    updateAnswer() { return { url: `/talks/answers/${this.answerEdit ? this.answerEdit.uuid : ''}/`, method: 'patch', params: { content: this.content } } },
  },
  props: ['questionEdit', 'answerEdit'],
  data: function () {
    return {
      content: ''
    }
  },
  watch: {
    questionEdit: function (question) {
      if (question) {
        this.content = question.content
      }
    },
    answerEdit: function (answer) {
      if (answer) {
        this.content = answer.content
      }
    }
  },
  computed: {
    placeholder() {
      if (this.isUpdateQuestion) {
        return '사장님의 일상을 남겨주세요!'
      } else if (this.isUpdateAnswer) {
        return '사장님의 의견을 남겨주세요!'
      } else if (this.isCreateQuestion) {
        return '사장님의 일상을 남겨주세요!'
      } else if (this.isCreateAnswer) {
        return '사장님의 의견을 남겨주세요!'
      } else {
        return ''
      }
    },
    isActivie() {
      return this.content.length >= 1
    },
    isUpdateQuestion() {
      if (this.$route.name === 'talks/:uuid' && this.questionEdit) { return true }
      return false
    },
    isUpdateAnswer() {
      if (this.$route.name === 'talks/:uuid' && this.answerEdit) { return true }
      return false
    },
    isCreateQuestion() {
      if (this.$route.name === 'talks') { return true }
      return false
    },
    isCreateAnswer() {
      if (this.$route.name === 'talks/:uuid' && !this.isUpdateQuestion && !this.isUpdateAnswer) { return true }
      return false
    },
  },
  created() {
    self = this
  },
  destroyed() {},
  methods: {
    async complete() {
      if (!(this.content && this.content.length >= 1)) {
        alert('내용을 입력해주세요.')
        return
      }

      if (this.isCreateQuestion) {
        let { data } = await this.createQuestion.fetch()
        this.$emit('createQuestion', data)
      } else if (this.isCreateAnswer) {
        let { data } = await this.createAnswer.fetch()
        this.$emit('createAnswer', data)
      } else if (this.isUpdateQuestion) {
        let { data } = await this.updateQuestion.fetch()
        this.$emit('updateQuestion', data)
      } else if (this.isUpdateAnswer) {
        let { data } = await this.updateAnswer.fetch()
        this.$emit('updateAnswer', data)
      }

      self.content = ''
    },
  },
}
</script>

<style lang="scss" scoped>
  #TalkInput {
    width:inherit;
    max-width:inherit;
    min-height: 59px;
    background-color: white;
    position: fixed;
    bottom: 0;
    padding: 9px 20px 9px 20px;
    border-top-width: 1px;
    border-top-color: #e1e9f3;
    &.active {
      box-shadow: 0 -4px 12px 0 rgba(0, 0, 0, 0.1);
    }

    textarea {
      box-sizing: border-box;
      width: calc(230% / 335 * 100);
      height: 40px;
      line-height: 16px;
      color: #333333;
      background-color: #f2f9ff;
      border: none;
      border-radius: 21px;
      outline: none;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
      padding: 11.5px 14px;
      &.active {
        background-color: #ffffff;
        border: solid 0.5px #d7e1ea;
      }
      @media screen and (max-width: 350px) {
        font-size: 14px;
        letter-spacing: -0.3px;
      }
      @media screen and (min-width: 350px) {
        font-size: 15px;
        letter-spacing: -0.2px;
      }
    }
    button {
      position: absolute;
      right: 20px;
      bottom: 9px;
      width: calc(83% / 335 * 100);
      height: 40px;
      font-weight: 700;
      font-size: 16px;
      letter-spacing: -0.23px;
      color: #ffffff;
      background-color: #333333;
      border-radius: 21px;
      float: right;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        background-color: #1baaf1;
      }
    }
  }
</style>
